<template>
  <div class="contain">
    <el-row :gutter="15">
      <el-col
        :xs="12"
        :sm="8"
        :md="8"
        v-for="(item, index) in cardData"
        :key="item.id"
      >
        <div class="oneCard" @click="linkDetail(item.id)">
          <!-- <div v-for="item in cardData" class="oneCard" :key="item.id" @click="linkDetail(item.id)"> -->
          <div>
            <img v-if="item.pic_set" class="img" :src="item.pic_set[0]" />
            <el-empty
              v-else
              class="img"
              :image-size="120"
              description="无图片"
            ></el-empty>
          </div>
          <div class="card-content">
            <div class="name">{{ item.goods_name }}</div>
            <div class="introduction">
              <div>{{ item.goods_type_name }}</div>
              <div class="date">{{ item.create_time }}</div>
            </div>
          </div>
          <!-- </div> -->
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    cardData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  methods: {
    linkDetail(id) {
      this.$router.push({
        path: `/pilotService/lostFound/lostFoundDetail?id=${id}`,
      });
    },
  },
};
</script>

<style scoped>
.contain {
  width: 100%;
  /* display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  margin: 5%; */
}
.oneCard {
  cursor: pointer;
  box-shadow: 0px 0px 2.8px rgba(0, 0, 0, 0.027),
    0px 0px 6.7px rgba(0, 0, 0, 0.037), 0px 0px 12.5px rgba(0, 0, 0, 0.044),
    0px 0px 22.3px rgba(0, 0, 0, 0.049), 0px 0px 41.8px rgba(0, 0, 0, 0.056),
    0px 0px 100px rgba(0, 0, 0, 0.07);
  border-radius: 10px;
  margin-bottom: 15px;
  /* width: 25%; */
  /* margin: 2%; */
}
.img {
  width: 100%;
  height: 14vmax;
  border-radius: 10px 10px 0 0;
}
.card-content {
  padding: 5%;
}
.name {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  font-weight: 700;
  font-style: normal;
  line-height: 5vh;
  font-size: 16px;
  color: #000000;
  text-align: left;
}
.introduction {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  line-height: 3vh;
  font-size: 13px;
  color: #9295a1;
}
@media only screen and (max-width: 768px) {
  /* .oneCard {
    width: 40%;
  } */
  .img {
    width: 100%;
    height: 15vh;
  }
  .name {
    font-size: 14px;
  }
  .introduction {
    font-size: 12px;
  }
}
</style>